import {
    Button,
    Card,
    Col,
    message,
    Row,
    Anchor,
    Form,
    Input,
    InputNumber,
    Modal, Select, DatePicker, AutoComplete
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import { isAllowedDomain, isDemoDomain } from "../../api/apiClient";
import { handleKiDATA } from "../../api/kiData";
import { updateDataContent, addIcon } from "../../utils/formUtils";
import { dayjsToISO } from "../../utils/dateFormat";
import { LoadingScreen } from "../ui/LoadingScreen";
import { SaveIcon } from "../ui/SaveIcon";
import { MyInputNumber } from "../ui/MyInputNumber";
import { useModals } from "../../hooks/useModals";
import { useGutachtenPersist } from "../../hooks/useGutachtenPersist";
import { useGutachtenData } from "../../hooks/useGutachtenData";
import { useParams } from "react-router-dom";
import {DeleteOutlined, FileTextOutlined, ThunderboltOutlined} from "@ant-design/icons";
import 'dayjs/locale/de';
import TextArea from "antd/es/input/TextArea";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { useSwitch } from '../../pages/SwitchContext';
import GutachtenShell from "./GutachtenShell";
const { Option } = Select;


const MENU_LINKS = [
    { href: '#kurzbeschreibung', title: 'Kurzbeschreibung' },
    { href: '#makrolage', title: 'Makrolage' },
    { href: '#stadtzentrum', title: 'Stadtzentrum, Geschäfte u. Einrichtungen' },
    { href: '#gebiet', title: 'Gebiet und Immissionen' },
    { href: '#verkehrsanbindung', title: 'Verkehrsanbindung' },
    { href: '#wirtschaftsdaten', title: 'Wirtschaftsdaten' },
    { href: '#beurteilung-lage', title: 'Beurteilung Lage' },
];


const FormContainer = () => {
    const [cardsNC, setCardsNC] = useState([]);
    const [formFormular1] = Form.useForm();
    const inputRefs = useRef({});
    const handleRef = (name, element) => {
        if (element) {
            inputRefs.current[name] = element;
        }
    };
    const { auftragID, gutachtenID } = useParams();
    const [selectedOption, setSelectedOption] = useState(null);
    const { isSwitchOn } = useSwitch();
    const { saveIcon, saveIcon1, isLoading, setIsLoading, updateTrigger, setUpdateTrigger, updateGutachten } = useGutachtenPersist(gutachtenID);
    const { modals, handleOpenTextbausteine, handleCloseTextbausteine, renderModals, selectedTextBausteine } = useModals();

    const { dataContentRef, initialValues, enumerationValues } = useGutachtenData(gutachtenID, {
        setIsLoading,
        updateTrigger,
        saveIcon,
        onLoad: (data) => {
            if (data.Lage?.Makrolage_NextCity) setCardsNC(data.Lage.Makrolage_NextCity);
        },
    });

    const handleSelectChange = (value) => setSelectedOption(value);

    const getAddress = (data) => {
        const AllgAng_Detail = data.AllgAng.AllgAng_Detail;
        let getAddressError = false;
        if(AllgAng_Detail.Strasse == null || AllgAng_Detail.Strasse == ""){
            message.error("Strasse (in Allgemeine Angaben) wird benötigt, um Textautomatisierung zu nutzen!");
            getAddressError = true;
        }
        if(AllgAng_Detail.NrZusatz == null || AllgAng_Detail.NrZusatz == ""){
            message.error("Nr / Zusatz (in Allgemeine Angaben) wird benötigt, um Textautomatisierung zu nutzen!")
            getAddressError = true;
        }
        if(AllgAng_Detail.PLZ == null || AllgAng_Detail.PLZ == ""){
            message.error("PLZ (in Allgemeine Angaben) wird benötigt, um Textautomatisierung zu nutzen!")
            getAddressError = true;
        }
        if(AllgAng_Detail.Ort == null || AllgAng_Detail.Ort == ""){
            message.error("Ort (in Allgemeine Angaben) wird benötigt, um Textautomatisierung zu nutzen!")
            getAddressError = true;
        }

        if(!getAddressError) {
            return AllgAng_Detail.Strasse+" "+AllgAng_Detail.NrZusatz + ", " +AllgAng_Detail.PLZ+" "+AllgAng_Detail.Ort;
        } else {
            return "";
        }
    }

    const triggerFocus = (name) => {
        if (inputRefs.current[name]) {
            inputRefs.current[name].focus();
        }
    };
    useEffect(() => {
        if (selectedTextBausteine) {
            formFormular1.setFieldsValue({ [modals[modals.length - 1].field]: selectedTextBausteine });
            triggerFocus(modals[modals.length - 1].field);
        }
    }, [selectedTextBausteine]); // Specify the dependencies to watch for changes

    const addCardNC = () => {

        const newCardNC = {
            MA_nearCity_Name: '',
            MA_Entfernung_km: '',
        };
        document.getElementById("button_new_component").hidden = true; // Button "Neue Komponente" verstecken, da nur eins im Status "undefined" existieren darf
        setCardsNC([...cardsNC, newCardNC]);
    };



    const deleteCardNC = (component, index, id) => {
        Modal.confirm({
            title: 'Komponente löschen',
            content: 'Möchten Sie diese Nächste Stadt wirklich löschen?',
            onOk() {
                deleteCardConfirmedNC(component, index, id);
            },
            onCancel() {
                console.log('Löschung abgebrochen');
            },
        });
    };
    const deleteCardConfirmedNC = (component, index, id) => {
       // console.log(id); //For later delete of upload
        const updatedCardsNC = [...cardsNC];
        updatedCardsNC.splice(index, 1); // Remove the card at the specified index
        setCardsNC(updatedCardsNC);
        updateDataContent(component, index, dataContentRef.current, "deleteComponent");
        updateGutachten(dataContentRef.current);
    };

    useEffect(() => formFormular1.resetFields(), [initialValues]);
    return (
        <div className={`${isSwitchOn ? 'bg-black' : 'bg-white'} sm:p-[20px] p-[10px] rounded-[30px]`}>
            {isLoading && <LoadingScreen />}
            {saveIcon1 && <SaveIcon saveIcon={saveIcon} />}
            {renderModals()}
            <h2 className={`${isSwitchOn ? 'text-white' : 'text-black'} font-bold text-16px  md:text-[28px] mb-[20px] generalText`}>Lage</h2>
            <div>
                {dataContentRef.current && initialValues && enumerationValues && ( // Bedingung überprüft, ob dataContentRef.current bereits vorhanden ist
                    <Form
                        form={formFormular1}
                        onValuesChange={(changedValues) => {
                            const updateByIDArray = ["Lage__Makrolage_NextCity"];
                            Object.entries(changedValues).forEach(([fieldName, value]) => {
                                const isoDate = dayjsToISO(value);
                                if (isoDate !== null || (value === null && fieldName)) {
                                    if (updateByIDArray.some(v => fieldName.includes(v))) {
                                        updateDataContent(fieldName, isoDate, dataContentRef.current, "updateByID");
                                    } else {
                                        updateDataContent(fieldName, isoDate, dataContentRef.current, "updateByIndex");
                                    }
                                    updateGutachten(dataContentRef.current, false);
                                }
                            });
                        }}
                        onBlur={(e) => {
                            if (e.target.type !== "button" && e.target.type !== undefined) {
                                const updateByIDArray = ["Lage__Makrolage_NextCity"];
                                const updateValue = e.target.type === "search"
                                    ? (setSelectedOption(null), selectedOption)
                                    : e.target.value;
                                if (e.target.closest?.('.ant-picker')) return;
                                if (e.target.id === "" || !e.target.id) return;
                                if (updateByIDArray.some(value => e.target.id.includes(value))) {
                                    updateDataContent(e.target.id, updateValue, dataContentRef.current, "updateByID");
                                } else {
                                    updateDataContent(e.target.id, updateValue, dataContentRef.current, "updateByIndex");
                                }
                                if (e.target.id.includes("undefined")) {
                                    updateGutachten(dataContentRef.current, true, false);
                                    const elements = document.getElementsByClassName("button_new_component");
                                    for (let i = 0; i < elements.length; i++) {
                                        elements[i].hidden = false;
                                    }
                                } else {
                                    updateGutachten(dataContentRef.current, false);
                                }
                            }
                        }}
                        initialValues={initialValues}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        layout="horizontal"
                    // style={{ maxWidth: 800 }}
                    >
                        <div id="kurzbeschreibung" className="scrollable-section">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Kurzbeschreibung</h3>
                            <div className={`allgemeineClass ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Kurzbeschreibung" name='Lage__Kurzbeschreibung_Lage'>
                                    <TextArea  autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__Kurzbeschreibung_Lage', element)} />
                                </Form.Item>
                            </div>
                        </div>
                        <div id="makrolage" className="scrollable-section">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Makrolage</h3>
                            <div className={`allgemeineClass ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Bundesland" name="Lage__MA_BundeslandV">
                                    <AutoComplete
                                        className={"AutoCompleteTextArea "}
                                        options={enumerationValues?.sub_com_MA_Bundesland?.map(
                                            (option, index) => ({ value: option, key: index })
                                        )}
                                        filterOption={(inputValue, option) =>
                                            option.value
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onChange={handleSelectChange} // Add your change handler if needed
                                    >
                                        <TextArea
                                            placeholder="Bundesland"
                                            autoSize={true}
                                            className="textInput"
                                        />
                                    </AutoComplete>

                                </Form.Item>
                                <Form.Item label="Landeshauptstadt" name='Lage__MA_Landeshauptstadt'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Landkreis" name='Lage__MA_Landkreis'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Kreisstadt" name='Lage__MA_Kreisstadt'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Ort" name='Lage__MA_Ort'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Ortsteil" name='Lage__MA_Ortsteil'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Einwohnerzahl Ort" name='Lage__MA_Einwohner_Ort'>
                                    <MyInputNumber className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Einwohnerzahl Ortsteil" name='Lage__MA_Einwohner_Ortsteil'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label={`Stichdatum Einwohnerzahl`} >
                                    <Form.Item name={`Lage__MA_Einwohner_Stichdatum`} noStyle>
                                        <DatePicker format={"DD.MM.YYYY"} className="inputsAll" />
                                    </Form.Item>
                                </Form.Item>
                                <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Beschreibung der Makrolage" name='Lage__MA_Beschreibung_Makrolage'>
                                    <TextArea  autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__MA_Beschreibung_Makrolage', element)} />
                                </Form.Item>
                                    {!isDemoDomain() && <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" onClick={() => handleKiDATA( formFormular1,triggerFocus, 'makrolage',"Lage__MA_Beschreibung_Makrolage",getAddress(dataContentRef.current),dataContentRef.current.AllgAng.AllgAng_Detail.ObjektartV)} style={{ float: 'right' }} ><ThunderboltOutlined /></Button>}
                                </div>

                            </div>
                            <div className="scrollable-section border-t border-gray-300">
                                <div
                                    className="flex justify-between items-center p-[10px]  md:p-[20px] pr-[3%] md:pr-[10%]">
                                    <h4 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Nächste
                                        Städte</h4>

                                </div>

                                {cardsNC.map((entry, index) => (
                                    <Card className={`pl-[3%] md:pl-[10%] ${isSwitchOn ? 'bgdark' : 'bgwhite'}`}
                                          size="small" key={index}>
                                        <div
                                            className={`flex justify-center  sacherCenterText ${isSwitchOn ? 'maxColor' : ''}`}>
                                            <Form.Item label={`Name der Stadt:`}
                                                       name={`Lage__Makrolage_NextCity__${entry.id}__MA_nearCity_Name`}>
                                                <Input className="inputsAll"/>
                                            </Form.Item>
                                            <div className="ml-[10px] gap-[10px] flex">
                                                <div style={{float: 'right', cursor: 'pointer'}}
                                                     onClick={() => deleteCardNC("Lage.Makrolage_NextCity", index, entry.id)}>
                                                    <RiDeleteBin5Fill
                                                        className="text-[#FF2E3B] w-[18px] h-[20px] mt-[40px] sm:mt-0"/>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className={`flex  justify-center sacherCenter1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                            <Form.Item label={`Entfernung in KM: `}
                                                       name={`Lage__Makrolage_NextCity__${entry.id}__MA_Entfernung_km`}>
                                                <MyInputNumber className="inputsAll"/>
                                            </Form.Item>
                                        </div>
                                    </Card>
                                ))}
                                <div className={`flex  justify-center sacherCenter1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                    <Button
                                        className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'} text-[10px] m-[20px] md:text-[14px] button_new_component rounded-[30px] border-none`}
                                        onClick={addCardNC} id={"button_new_component"}>Stadt hinzufügen</Button>
                                </div>
                            </div>
                        </div>
                        <div id="stadtzentrum"
                             className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Stadtzentrum,
                                Geschäfte u. Einrichtungen</h3>
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Stadtzentrum" name='Lage__Stadtzentrum_TB' >
                                    <TextArea className="textInput" autoSize={true}  ref={(element) => handleRef('Lage__Stadtzentrum_TB', element)}/>
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__Stadtzentrum_TB', 'Stadtzentrum', 'Stadtzentrum')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>

                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Geschäfte" name='Lage__Geschaefte_TB'>
                                    <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__Geschaefte_TB', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__Geschaefte_TB', 'Geschäfte', 'Geschäfte')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>

                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Einrichtungen" name='Lage__Einrichtungen_TB'>
                                    <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__GEinrichtungen_TB', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__Einrichtungen_TB', 'Einrichtungen', 'Einrichtungen')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>

                        </div>
                        <div id="gebiet" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Gebiet und Immissionen</h3>
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Freizeit/Naherholung" name='Lage__Freizeit_TB'>
                                    <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__Freizeit_TB', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__Freizeit_TB', 'Freizeit/Naherholung', 'Freizeit/Naherholung')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>

                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Art des Gebiets" name='Lage__ArtDesGebiets_TB'>
                                    <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__ArtDesGebiets_TB', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__ArtDesGebiets_TB', 'Art des Gebiets', 'Art des Gebiets')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>

                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Immissionen/Beeinträchtigungen" name='Lage__Immissionen_TB'>
                                    <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__Immissionen_TB', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__Immissionen_TB', 'Immissionen/Beeinträchtigungen', 'Immissionen/Beeinträchtigungen')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>

                        </div>
                        <div id="verkehrsanbindung" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h3 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Verkehrsanbindung</h3>
                            <div className="allgemeineClass">
                                <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                    <Form.Item label="ÖPNV" name='Lage__OePNV_TB'>
                                        <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__OePNV_TB', element)} />
                                    </Form.Item>
                                    <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__OePNV_TB', 'ÖPNV', 'ÖPNV')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                                </div>

                                <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                    <Form.Item label="Nächstgelegene Straße" name='Lage__NaechstegelegeneStrassen'>
                                        <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__NaechstegelegeneStrassen', element)} />
                                    </Form.Item>
                                    <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__NaechstegelegeneStrassen', 'Straßen', 'Strassen')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                                </div>

                                <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                    <Form.Item label="Bundesstraßen" name='Lage__Bundesstrassen'>
                                        <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__Bundesstrassen', element)} />
                                    </Form.Item>

                                    <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__Bundesstrassen', 'Bundesstraßen', 'Bundesstrassen')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                                </div>

                                <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                    <Form.Item label="Autobahn und Zufahrt" name='Lage__AutobahnUndZufahrt_TB'>
                                        <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__AutobahnUndZufahrt_TB', element)} />
                                    </Form.Item>

                                    <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__AutobahnUndZufahrt_TB', 'Autobahn', 'Autobahn')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                                </div>

                                <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                    <Form.Item label="Bahnhof" name='Lage__Bahnhof_TB'>
                                        <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__Bahnhof_TB', element)} />
                                    </Form.Item>

                                    <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__Bahnhof_TB', 'Bahnhof', 'Bahnhof')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                                </div>

                                <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                    <Form.Item label="Flughafen" name='Lage__Flughafen_TB'>
                                        <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__Flughafen_TB', element)} />
                                    </Form.Item>

                                    <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__Flughafen_TB', 'Flughafen', 'Flughafen')} style={{ float: 'right' }} ><FileTextOutlined /></Button>
                                </div>

                            </div>
                        </div>
                        <div id="wirtschaftsdaten" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <h4 className={`font-bold text-16px mb-[12px]  md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Wirtschaftsdaten</h4>
                            <div className={`allgemeineClass ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Informationen" name='Lage__Wirtschaftsdaten__WD_Informationen'>
                                    <TextArea className="textInput" />
                                </Form.Item>
                                <Form.Item label="Kaufkraft" name='Lage__Wirtschaftsdaten__WD_Kaufkraft'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Arbeitslosenquote" name='Lage__Wirtschaftsdaten__WD_Arbeitslosenquote'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Kaufkraft Ortsteil" name='Lage__Wirtschaftsdaten__WD_Kaufkraft_Ortsteil'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                                <Form.Item label="Arbeitslosenquote Ortsteil" name='Lage__Wirtschaftsdaten__WD_Arbeitslosigkeit_Ortsteil'>
                                    <Input className="inputsAll" />
                                </Form.Item>
                            </div>
                        </div>
                        <div id="beurteilung-lage" className="scrollable-section border-t border-gray-300 pt-[20px] pb-[20px]">
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <h3 className={`font-bold text-16px mb-[12px] w-[335px] md:text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Beurteilung der Mikrolage</h3>
                                {!isDemoDomain() && <Button className="mt-[35px] md:mt-0 md:ml-[13px] mb-[20px] text-[#FF2E3B] fileIcon" onClick={() => handleKiDATA( formFormular1,triggerFocus, 'mikrolage',"Lage__Beurteilung_Lage",getAddress(dataContentRef.current),dataContentRef.current.AllgAng.AllgAng_Detail.ObjektartV)} style={{ float: 'right' }} ><ThunderboltOutlined /></Button>}
                            </div>
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Beurteilung der Lage" name='Lage__Beurteilung_Lage'>
                                    <TextArea autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__Beurteilung_Lage', element)} />
                                </Form.Item>
                                <Button className="mt-[35px] md:mt-0 md:ml-[13px] ml-[20px] text-[#FF2E3B] fileIcon" htmlType="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleOpenTextbausteine('Lage__Beurteilung_Lage', 'Beurteilung der Lage', 'Lage')} style={{ float: 'right' }} ><FileTextOutlined /></Button>

                            </div>
                            <div className={`flex textOuter justify-start gap-[10px] ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Form.Item label="Beschreibung der Verkehrslage" name='Lage__Beurteilung_Verkehrslage'>
                                    <TextArea  autoSize={true} className="textInput"  ref={(element) => handleRef('Lage__Beurteilung_Verkehrslage', element)} />
                                </Form.Item>
                                   </div>
                        </div>

                    </Form>
                )}
            </div>
        </div>
    );
};

const Lage = () => (
    <GutachtenShell menuLinks={MENU_LINKS}>
        <FormContainer />
    </GutachtenShell>
);

export default Lage;
